import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import { mailDomainsBlacklist, fieldsFilter, hubspot_contentDownloadShortForm_fields } from '../utils/hubspot_utils.js';

const PORTAL_ID = '7284441';
const FORM_ID = 'c414c05c-38c2-4378-a0d6-a423af095238';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
} 

export class DemoFormShortPDFNoBackground extends React.Component {

  state = { error: false,  mailError: false, submitted: false };

  validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")
  });
  

  handleSubmit = (values, { resetForm }) => {    
    window.open(this.props.pdfUrl,'_blank');

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));  
    const referrer = sessionStorage.getItem('Referrer');  
    
    const fields = [
      {name: 'email', value: values.email},
    ]
    
    if (UTMparams && typeof UTMparams[0] === "string" ){
      fields.push({name: UTMparams[0], value: UTMparams[1]})
      
    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }
    
    fields.push({name: "referrer", value: referrer || "Empty"});
    const context = {
      pageUri: url,
      pageName: pageTitle
    }

    const filteredFieldsArray = fieldsFilter(fields, hubspot_contentDownloadShortForm_fields);

    // ============ Sending to Hubspot ============ // 
    axios.request({
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
      data: JSON.stringify({
        fields: filteredFieldsArray,
        context: context
      })
    })
    .then(res=>{
      this.setState({ submitted: true });
      this.btn.setAttribute("disabled", "disabled");
      this.btn.removeAttribute("disabled");
    }) 
    .catch(error => {
      this.setState({ error: true })
      return
    })

    // ============ Sending to Charthop API (Slack) ============ // 
    axios 
      .request({
        method: "POST",
        url: "https://api.charthop.com/contact",
        data: {
          ...values, 
          source: this.props.source
          }
      })
  };

  render() {
    if (this.state.submitted) {
      return (
        <div className="form-header-box background-none col-xs-12 col-md-5 col-sm-8 text-center">
          <div className="form-pdf">
            <div className="pt-callout pt-intent-primary sectionSpacing pb-0 pt-submission-success">
              <div className="successBunny"></div> 
              <p className= "white-font">Great! We'll email you with a copy.<br></br> <br></br>
              To download the PDF <a href={this.props.pdfUrl} className ="white-font" target="_blank"><u>click here</u></a>.</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Formik
        initialValues={{ name: "", email: "", company_size: "", note: "" }}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit} 
        render={form => (
            <div className="form-header-box col-xs-12 col-md-5 col-sm-8 text-center">
                <div className="form-pdf">
                <form
                  className="demolongform"
                  onSubmit={form.handleSubmit}
                >         
                  <div className="demoshortform-input">
                    <div className={toFormGroupClass("email", form)} >
                    <label className="pt-label" htmlFor="email">
                        Email Address
                    </label>
                    <div className="pt-form-email-container">
                    <input
                      id="email"
                      name="email"
                      type="text"
                      className="input-text companyEmail"
                      value={form.values.email}
                      onChange={form.handleChange}
                      placeholder="Company Email"
                    />
                    <img
                      alt="error"
                      className="pt-form-image pt-form-image-danger"
                      src="/icons/Icon-material-error-outline.svg"
                    />
                    <img
                      img="complete"
                      className="pt-form-image pt-form-image-success"
                      src="/icons/Icon-material-done.svg"
                    />
                  </div>
                    {form.touched.email && form.errors.email && (
                        <div className="pt-form-helper-text">{form.errors.email}</div>
                    )}
                    
                    </div>
            
                    <button ref={btn => { this.btn = btn; }} type="submit" className="button primary">
                      DOWNLOAD
                    </button>
                  </div>

                    <p className="p-formPDF opt-in pt-0 pb-0 mb-0">By downloading this PDF, you agree to opt-in to emails from ChartHop.</p>

                    {this.state.mailError && (
                      <div className="pt-callout pt-intent-danger" style={{ marginTop: 10 }}>
                        Sorry! Please use a company email. If your issue persists, send a note to {" "}
                        <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                      </div>
                    )}

                    {this.state.error && (
                      <div
                          className="pt-callout pt-intent-danger"
                          style={{ marginTop: 10 }}
                      >
                          <p className="errorTextHeaderForm"><span role="img" aria-label="warning">&#128680;</span>
                          Sorry, but we had an unexpected problem submitting your request.
                          Try again later, or send a note to{" "}
                          <a href="mailto:hello@charthop.com">hello@charthop.com</a>.</p>
                      </div>
                    )}
                </form>
                </div>
            </div>
        )}
      />
    );
  }
}
